export const isI18nString = (string: string) => {
  const i18nString = /[a-zA-Z]:[a-zA-Z]/;
  return i18nString.test(string);
};
